var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02959 0C7.75148 0 10 2.24852 10 5.02959C10 7.92899 6.86391 12.071 5.02959 14.142C3.19527 12.071 0 7.92899 0 5.02959C0 2.24852 2.24852 0 5.02959 0ZM5.02959 2.54438C6.21302 2.54438 7.21894 3.5503 7.21894 4.73373C7.21894 5.97633 6.21302 6.98225 5.02959 6.98225C3.78698 6.98225 2.78107 5.97633 2.78107 4.73373C2.78107 3.5503 3.78698 2.54438 5.02959 2.54438Z",
    fill: "#DB9600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.6972b0ef3019f73139a2e04e7b4b7fec.svg";
export { ForwardRef as ReactComponent };